// /eprov2/ui

const Config = {
  defaultPath: '/auth/loginV2',
  //defaultPath: '/bulk/dashboard',
  // basename: 'kr-creation',
  // localUrl
  baseUrl: `${window?.location?.href?.split('#')[0].substring(0, window?.location?.href?.split('#')[0].length - 1)}/eprov2api`,
  baseUrlForSampleData: `${window?.location?.href
    ?.split('#')[0]
    .substring(0, window?.location?.href?.split('#')[0].length - 1)}/samples/SamplePartyMasterData.xlsx`,
  // baseUrl: `${window?.location?.href?.split('#')[0].substring(0, window?.location?.href?.split('#')[0].length - 1)}/eprov2api`,
  // baseUrlForSampleData: `${window?.location?.href
  //     ?.split('#')[0]
  //     .substring(0, window?.location?.href?.split('#')[0].length - 1)}/samples/SamplePartyMasterData.xlsx`,


  // baseUrl: 'http://192.168.1.42/eprotrial/eprov2api',

  // baseUrl: 'http://192.168.1.42/eprov2api',

  //baseUrl: 'http://techamour.shop/eprotex/eprov2api',

  //30 03 2023
  //baseUrl: 'http://eprotex.shop/eprotex/eprov2api',


  // baseUrl: 'https://eprotex.software/eprotex/eprov2api',


  //dev remote api (Common DB)
  layout: 'vertical',
  subLayout: '',

  collapseMenu: false,
  layoutType: 'menu-light',
  headerBackColor: 'header-blue',
  rtlLayout: false,
  navFixedLayout: false,
  headerFixedLayout: true,
  boxLayout: false,
  alertTimeout: 1500
};
export default Config;
